import React from "react";
import styled from "styled-components";
import * as echarts from 'echarts';
import axios from 'axios';
import { Loading } from "../layout/Loading";
import { format } from 'date-fns';
import {
  SectionHeadline
} from '../styled';
import bnbChainPng from '../../images/bnbchain.png';
import ethLogPng from '../../images/ethlogo.png';
import snowLogoPng from '../../images/snowlogo.png';
import tronLogoPng from '../../images/tron-logo.png';

const Container = styled.div`
    padding: 29px 0 0;
    margin: 0 auto;
    display: block;
    background-color: #F1F3F9;
    text-align: center;
`
const PorContainer = styled.div`
    max-width: 990px;
    margin: 0 auto;
    padding: 48px 0 80px;
    text-align: left;
    display: flex;
    justify-content: space-around;
`
const PorLeftBox = styled.div`
    background: #fff;
    padding: 30px 20px 40px;
    width: 560px;
    border-radius: 10px;
    position: relative;
`

const PorLeftTitle = styled.div`
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 21px;
`

const PorLeftValueBox = styled.div`
    display: flex;
    justify-content: space-around;
`
const PorValueBox = styled.div`
    display: block;
`

const PorValueType = styled.div`
    color: #767980;
    font-size: 10px;
    line-height: 18px;
`

const PorValue = styled.div`
    font-size: 20px;
    font-weight: bold;
`
const PorCharts = styled.div`
    width: 100%;
    height: 200px;
`
const ChainBox = styled.div`
  padding: 0 0 0 110px;
`

const ChainImgBox = styled.div`
  display: flex;
  justify-content: space-around;
  width: 166px;
  flex-wrap: wrap;
  float: left;
`

const ChainLogo = styled.img`
  width: 60px;
  display: block;
  margin: 0 22px 7px 0;
`

const ChainlinkBox = styled.div`
`
const ChainlinkLogo = styled.img`
  width: 120px;
  margin-left: 25px;
`

const PorRightBox = styled.div`
  padding: 20px 0 0 55px;
  width: 430px;
  display: flex;
    flex-direction: column;
    justify-content: center;
`

const PorDesc = styled.div`
  margin: 30px 0 0px;
  line-height: 24px;
  word-wrap:break-word;
`
const PorUpdateTime = styled.div`
  color: #B0B2C2;
  position: absolute;
  bottom: 15px;
  right: 85px;
  font-size: 10px;
`

function formatNumberWithCommas(num) {
  return num.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function HomepagePor({ input }) {
  const { primary } = input;
  const [tickerState, setTickerState] = React.useState(null);
  React.useEffect(() => {
    const effect = async function () {
      let armaninoResData = null;
      let armaninoTokenData = null;
      try {
        const armaninoRes = await axios.get(process.env.ARMANINO_NEW_URL)
        if (armaninoRes.status === 200 && armaninoRes.data) {
          armaninoResData = armaninoRes.data;
          armaninoTokenData = armaninoResData.token;
          setTickerState({
            totalTrust: armaninoResData.totalTrust,
            totalToken: armaninoResData.totalToken,
            updateTime: armaninoResData.updatedAt,
          });
          const Ethereum = formatNumberWithCommas(armaninoTokenData.find(v => v.tokenName === 'TUSD (ETH)').totalTokenByChain || '');
          const TRON = formatNumberWithCommas(armaninoTokenData.find(v => v.tokenName === 'TUSD (TRON)').totalTokenByChain || '');
          const Avalanche = formatNumberWithCommas(armaninoTokenData.find(v => v.tokenName === 'TUSD (AVAX)').totalTokenByChain || '');
          const BinanceChain = formatNumberWithCommas(armaninoTokenData.find(v => v.tokenName === 'TUSD (BNB)').totalTokenByChain || '');
          const BSC = formatNumberWithCommas(armaninoTokenData.find(v => v.tokenName === 'TUSD (BSC)').totalTokenByChain || '');
          var myChart = echarts.init(document.getElementById('charts'));
          myChart.setOption(
            {
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                textStyle: {
                  fontSize: 12,
                },
                formatter: function (params, value) {
                  let str = ''
                  if (params[0].name === 'Circulating Supply') {
                    str += `Ethereum: <b>${Ethereum}</b> <br> TRON: <b>${TRON}</b> <br> Avalanche: <b>${Avalanche}</b> <br> BNB Beacon Chain: <b>${BinanceChain}</b> <br> BNB Smart Chain: <b>${BSC}</b>`
                  }
                  return str;
                },
              },
              grid: {
                left: '11%',
                right: '12%',
                bottom: '0%',
                top: '20%',
                containLabel: true
              },
              xAxis: {
                type: 'category',
                show: false,
                data: ['Circulating Supply', 'Bank Reverses']
              },
              yAxis: {
                type: 'value',
                minInterval: 0.4,
                axisLabel: {
                  formatter: '{value} B'
                }
              },
              series: [
                {
                  data: [
                    {
                      value: armaninoResData.totalToken / 1000000000,
                      itemStyle: {
                        color: '#185BFF',
                        borderRadius: [7, 7, 0, 0],
                      },
                    },
                    {
                      value: armaninoResData.totalTrust / 1000000000,
                      itemStyle: {
                        color: '#FF7200',
                        borderRadius: [7, 7, 0, 0],
                      },
                    }
                  ],
                  type: 'bar',
                  barWidth: '16%',
                }
              ]
            }
          );
        } else {
          throw new Error(`Error ${armaninoRes.status},${armaninoRes.data}`)
        }
      } catch (e) {
        console.error(e)
      }
    }
    effect();
  }, [])
  return (
    <Container>
      <PorContainer>
        <PorLeftBox>
          {!tickerState &&
            <Loading text="Loading..." spinTopColor="#F1F3F9" />
          }
          {tickerState && !tickerState.error &&
            <>
              <PorLeftTitle>Balances</PorLeftTitle>
              <PorLeftValueBox>
                <PorValueBox>
                  <PorValueType>Circulating Supply</PorValueType>
                  <PorValue>{formatNumberWithCommas(tickerState.totalToken)}</PorValue>
                </PorValueBox>
                <PorValueBox>
                  <PorValueType>Bank Reverses</PorValueType>
                  <PorValue>${formatNumberWithCommas(tickerState.totalTrust)}</PorValue>
                </PorValueBox>
              </PorLeftValueBox>
              <PorCharts id="charts" />
              <ChainBox>
                <ChainImgBox>
                  <a href="https://etherscan.io/address/0x0000000000085d4780b73119b644ae5ecd22b376" target="_blank">
                    <ChainLogo src={ethLogPng} alt="eth chain logo" />
                  </a>
                  <a href="https://tronscan.org/#/contract/TUpMhErZL2fhh4sVNULAbNKLokS4GjC1F4" target="_blank">
                    <ChainLogo src={tronLogoPng} alt="tron chain logo" />
                  </a>
                  <a href="https://bscscan.com/address/0x40af3827f39d0eacbf4a168f8d4ee67c121d11c9" target="_blank">
                    <ChainLogo src={bnbChainPng} alt="bnb smart chain logo" />
                  </a>
                  <a href="https://snowtrace.io/token/0x1C20E891Bab6b1727d14Da358FAe2984Ed9B59EB" target="_blank">
                    <ChainLogo src={snowLogoPng} alt="snowtrace chain logo" />
                  </a>
                </ChainImgBox>
                <ChainlinkBox>
                  <a href="https://data.chain.link/ethereum/mainnet/reserves/tusd-por" target="_blank">
                    <ChainlinkLogo src="https://chain.link/badge-proof-of-reserve-white" alt="proof of reserve secured with chainlink" />
                  </a>
                </ChainlinkBox>
              </ChainBox>
              <PorUpdateTime>Last Update: {format(new Date(tickerState.updateTime), 'MMMM D, YYYY, HH:mm:ss')}</PorUpdateTime>
            </>
          }
        </PorLeftBox>
        <PorRightBox>
          <SectionHeadline>{primary.title.text}</SectionHeadline>
          <PorDesc>{primary.desc.text}</PorDesc>
          <PorDesc>{primary.subdesc.text}</PorDesc>
        </PorRightBox>
      </PorContainer>
    </Container>
  )
}

export { HomepagePor }